import * as tslib_1 from "tslib";
import * as React from 'react';
import * as undoActions from 'owa-mail-undo';
import App from 'owa-application/lib/components/App';
import checkAndCreateNewMessage from 'owa-mail-message-actions/lib/actions/checkAndCreateNewMessage';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import Droppable from 'owa-dnd/lib/components/Droppable';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import FolderPaneExpansionSource from 'owa-mail-store/lib/store/schema/FolderPaneExpansionSource';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import GroupCommandBarView from './GroupCommandBarView';
import groupHeaderCommandBarStore from 'owa-group-header-store/lib/store/CommandBarStore';
import GroupHeaderNavigationButton from 'owa-group-header-store/lib/store/schema/NavigationButton';
import GroupView from './GroupView';
import Header from 'owa-header/lib/components/Header';
import LeftRail, { HamburgerButton } from 'owa-left-rail';
import MailCommandBarView from './MailCommandBarView';
import MailSearchBoxContainer from './MailSearchBoxContainer';
import mailStrings from 'owa-strings/owa-mail-strings';
import MailView from './MailView';
import ModuleSwitcher, { Module } from 'owa-module-switcher';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import setFolderPaneWidth from 'owa-mail-module-actions/lib/actions/setFolderPaneWidth';
import setTypeOfItemBeingDragged from 'owa-mail-store/lib/actions/setTypeOfItemBeingDragged';
import store from 'owa-mail-store/lib/store/Store';
import { AdsPanelStub } from 'owa-mail-ads-stub';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { composeStore, lazyOpenCompose } from 'owa-mail-compose-store';
import { exitSearch, SearchScenarioId } from 'owa-search';
import { FloatingComposeContainer } from 'owa-mail-compose-view';
import { FolderPane } from 'owa-mail-folder-forest-view';
import { getActiveTab } from 'owa-tab-store';
import { getCommands } from 'owa-mail-hotkeys';
import { getEnterpriseRightHeaderCharms } from 'owa-header/lib/components/Header';
import { getListViewDimensions } from 'owa-mail-list-dimensions';
import { getMailMenuItemShouldDisable } from 'owa-mail-filterable-menu-behavior';
import { getOwaUrlWithAddedQueryParameters } from 'owa-url';
import { getSelectedGroupId, isGroupSelected, lazyIsPrivateUnjoinedGroup } from 'owa-group-utils';
import { ImmersiveReaderContainer } from 'owa-immersive-reader';
import { isAnySxSDisplayed } from 'owa-sxs-store';
import { isAppPaneUnderlayExpanded } from 'owa-application';
import { IsChildConsumerUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { isDumpsterSearchTable } from 'owa-mail-search-store';
import { isDumpsterTable, listViewStore } from 'owa-mail-list-store';
import { IsGroupsEnabled } from 'owa-group-feature-flags';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { keydownHandler, addGlobalHotkey } from 'owa-hotkeys';
import { lazySubscribeToResizeEvent, lazyUnsubscribeFromResizeEvent } from 'owa-resize-event';
import { lazyTriggerResizeEvent } from 'owa-resize-event';
import { LeftnavUpsell } from '../../../owa-mail-leftnavupsell/lib';
import { LightningId } from 'owa-lightning-v2';
import { logCalendarUsage } from 'owa-shared-analytics';
import { LostFocusAlert } from 'owa-mail-lost-focus-alert';
import { MailQuickSwitcherEntrypoint } from 'owa-mail-quick-switcher';
import { MailSearchBoxContainer as NewMailSearchBoxContainer } from 'owa-mail-search';
import { observer } from 'mobx-react';
import { OwaSuiteHeader } from 'owa-suite-header';
import { parse } from 'querystring';
import { PopoutContainer, PopoutSource } from 'owa-popout-container';
import { PremiumDomainConnectFirstStepLightable } from 'owa-domain-connect';
import { resetFocus } from 'owa-mail-focus-manager';
import { ResizeHandle } from 'owa-resize-handle';
import { selectDefaultFolder } from 'owa-mail-folder-forest-actions';
import { selectFolder } from 'owa-mail-folder-forest-actions';
import { setShowFolderPane } from 'owa-mail-module-actions';
import { trace } from 'owa-trace';
import mailStore from 'owa-mail-store/lib/store/Store';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import * as markRead from 'owa-mail-mark-read-actions';
import { selectNextRow, selectPreviousRow } from 'owa-mail-actions';
import { getFolderListWidth, getLeftNavWidth, getSearchBoxLeftPadding, lazyToggleFolderPaneExpansion, MIN_NAVIGATION_BAR_WIDTH, MAX_NAVIGATION_BAR_WIDTH, } from 'owa-mail-module-actions';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import { PrivateDistributionlistModalEditor } from 'owa-favorite-pdl-editor';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getSelectedPublicFolderId, isPublicFolderSelected } from 'owa-publicfolder-utils';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
var styles = require('./MailModule.scss');
var classNames = require('classnames/bind').bind(styles);
var DRAG_HINT_CHECK_PERIOD_IN_MILLISECONDS = 3000;
var hotkeyDisposeFunctions = [];
var MailModule = /** @class */ (function (_super) {
    tslib_1.__extends(MailModule, _super);
    function MailModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderHeader = function () {
            var searchBoxComponent = isMailFeatureEnabled('sea-commonSearchBox') ? (React.createElement(NewMailSearchBoxContainer, { isDisabled: _this.isSearchDisabled(), ref: function (ref) { return (_this.newSearchBoxRef = ref); } })) : (React.createElement(MailSearchBoxContainer, { ref: function (searchRef) { return (_this.searchBoxRef = searchRef); }, disabled: _this.isSearchDisabled() }));
            return isControlFeatureEnabled('fwk-o365shellheader') ? (React.createElement(OwaSuiteHeader, { rightCharms: getEnterpriseRightHeaderCharms(), userConfiguration: getUserConfiguration(), searchAlignmentWidth: getSearchBoxLeftPadding() }, !_this.isSearchHidden() && searchBoxComponent)) : (React.createElement(Header, { headerLeftSectionStyle: { maxWidth: getSearchBoxLeftPadding() } }, !_this.isSearchHidden() && searchBoxComponent));
        };
        _this.toggleFolderPaneExpansion = function () {
            lazyToggleFolderPaneExpansion.importAndExecute();
        };
        _this.isPrivateUnjoinedGroup = function () {
            if (isGroupSelected()) {
                var isPrivateUnjoinedGroup = lazyIsPrivateUnjoinedGroup.tryImportSync();
                if (isPrivateUnjoinedGroup) {
                    return isPrivateUnjoinedGroup(getSelectedGroupId());
                }
            }
            return false;
        };
        // VSO Bug 18257: preventDefault needs to be false
        // in order to let the keypress go to the password box of the PDF viewer in Chrome
        _this.newMessage = function () {
            // do nothing if SxS is showing
            if (!isAnySxSDisplayed()) {
                if (_this.showPublicFolderView()) {
                    checkAndCreateNewMessage('Keyboard', getSelectedPublicFolderId());
                }
                else {
                    checkAndCreateNewMessage('Keyboard', getSelectedGroupId());
                }
            }
        };
        _this.gotoMail = function () {
            window.location.assign(getOwaUrlWithAddedQueryParameters({ path: '/mail' }));
        };
        _this.gotoCalendar = function () {
            window.location.assign(getOwaUrlWithAddedQueryParameters({ path: '/calendar' }));
        };
        _this.gotoPeople = function () {
            window.location.assign(getOwaUrlWithAddedQueryParameters({ path: '/people' }));
        };
        _this.gotoTasks = function () {
            window.location.assign(getOwaUrlWithAddedQueryParameters({ path: '/tasks' }));
        };
        _this.gotoInbox = function () {
            var inboxId = folderNameToId('inbox');
            selectFolder(inboxId, 'primaryFolderTree', 'Keyboard' /* actionSource */);
        };
        _this.gotoDrafts = function () {
            var draftsId = folderNameToId('drafts');
            selectFolder(draftsId, 'primaryFolderTree', 'Keyboard' /* actionSource */);
        };
        _this.gotoSearch = function () {
            if (isMailFeatureEnabled('sea-commonSearchBox')) {
                _this.newSearchBoxRef.setFocus();
            }
            else {
                _this.searchBoxRef.setFocus();
            }
        };
        _this.onDragLeave = function () {
            trace.info('onDragLeave');
            _this.setDataItemType(null);
            _this.clearPendingDragHintRemover();
        };
        _this.onDragOver = function (dragInfo) {
            _this.lastDragOverTime = Date.now();
            if (!_this.pendingDragHintRemover) {
                _this.pendingDragHintRemover = setInterval(function () {
                    trace.info('Check last DragOver time');
                    // If we haven't received any dragOver event within the period, let's hide the drag hint.
                    if (Date.now() - _this.lastDragOverTime >= DRAG_HINT_CHECK_PERIOD_IN_MILLISECONDS) {
                        _this.setDataItemType(null);
                        _this.clearPendingDragHintRemover();
                    }
                }, DRAG_HINT_CHECK_PERIOD_IN_MILLISECONDS);
            }
            _this.setDataItemType(dragInfo.itemType);
        };
        _this.onDrop = function (dragData) {
            _this.setDataItemType(null);
            _this.clearPendingDragHintRemover();
        };
        _this.onClickLink = function (module) {
            if (module == Module.Calendar) {
                logCalendarUsage('ModuleSwitchToCalendar', { source: 'leftRail' });
            }
        };
        return _this;
    }
    MailModule.prototype.componentDidMount = function () {
        // Set initial focus after component is mounted
        resetFocus();
        lazySubscribeToResizeEvent.importAndExecute(function () {
            return setShowFolderPane(FolderPaneExpansionSource.WindowResize);
        });
        this.initializeMailHotKeys();
    };
    MailModule.prototype.componentWillUnmount = function () {
        lazyUnsubscribeFromResizeEvent.importAndExecute(function () {
            return setShowFolderPane(FolderPaneExpansionSource.WindowResize);
        });
        this.disposeMailHotKeys;
    };
    // default options are: preventDefault: true, stopPropagation: true, allowHotkeyOnTextFields: false
    MailModule.prototype.initializeMailHotKeys = function () {
        hotkeyDisposeFunctions.push(addGlobalHotkey(getCommands().newMail, this.newMessage, { preventDefault: false }), addGlobalHotkey(getCommands().gotoMail, this.gotoMail), addGlobalHotkey(getCommands().gotoCalendar, this.gotoCalendar), addGlobalHotkey(getCommands().gotoPeople, this.gotoPeople), addGlobalHotkey(getCommands().gotoTasks, this.gotoTasks), addGlobalHotkey(getCommands().gotoInbox, this.gotoInbox), addGlobalHotkey(getCommands().gotoDrafts, this.gotoDrafts), addGlobalHotkey(getCommands().gotoSent, this.gotoSentItems), addGlobalHotkey(getCommands().gotoSearch, this.gotoSearch));
    };
    MailModule.prototype.disposeMailHotKeys = function () {
        hotkeyDisposeFunctions.forEach(function (disposalFunctionPromise) {
            disposalFunctionPromise.then(function (disposalFunction) { return disposalFunction(); });
        });
        hotkeyDisposeFunctions = [];
    };
    MailModule.prototype.showGroupView = function () {
        return IsGroupsEnabled() && isGroupSelected();
    };
    MailModule.prototype.showPublicFolderView = function () {
        return isPublicFolderSelected() && isFeatureEnabled('pf-post');
    };
    MailModule.prototype.renderRightPane = function () {
        var userConfiguration = getUserConfiguration();
        var tableQuery = listViewStore.tableViews.get(listViewStore.selectedTableViewId)
            .tableQuery;
        var isDumpsterOrDumpsterSearchTable = isDumpsterTable(tableQuery) || isDumpsterSearchTable(tableQuery);
        var readingPanePosition = userConfiguration.UserOptions.GlobalReadingPanePositionReact;
        var activeTab = getActiveTab();
        var listViewDimensions = getListViewDimensions();
        var commonMailViewProps = {
            activeTab: activeTab,
            isDumpsterOrDumpsterSearchTable: isDumpsterOrDumpsterSearchTable,
            listViewDimensions: listViewDimensions,
            readingPanePosition: readingPanePosition,
        };
        var isInGroupView = this.showGroupView();
        return (React.createElement("div", { className: styles.rightPane }, isInGroupView ? (React.createElement(React.Fragment, null,
            React.createElement(GroupCommandBarView, tslib_1.__assign({}, commonMailViewProps)),
            React.createElement(GroupView, tslib_1.__assign({}, commonMailViewProps)))) : (React.createElement(React.Fragment, null,
            React.createElement(MailCommandBarView, tslib_1.__assign({}, commonMailViewProps)),
            React.createElement(MailView, tslib_1.__assign({}, commonMailViewProps))))));
    };
    MailModule.prototype.render = function () {
        var isPaneExpanded = store.mailModule.showFolderPane;
        var emptyDropViewState = createDropViewState();
        var leftNavWidth = getLeftNavWidth();
        return (React.createElement(App, { renderHeader: this.renderHeader },
            isMailFeatureEnabled('cmp-throwOnLostFocus') ? React.createElement(LostFocusAlert, null) : null,
            isMailFeatureEnabled('cmp-quickSwitcher') ? React.createElement(MailQuickSwitcherEntrypoint, null) : null,
            React.createElement(Droppable, { classNames: styles.mailMain, onDrop: this.onDrop, onDragOver: this.onDragOver, onDragLeave: this.onDragLeave, dropViewState: emptyDropViewState, shouldIgnoreTransientOnDragLeave: true, bypassActOnDrop: true },
                React.createElement("div", { className: styles.paneContainer },
                    React.createElement("div", { tabIndex: -1, role: 'region', "aria-label": mailStrings.navigationPaneLabel, className: styles.leftPane, style: { width: leftNavWidth }, "data-min-width": MIN_NAVIGATION_BAR_WIDTH, "data-max-width": MAX_NAVIGATION_BAR_WIDTH },
                        this.renderNewMessageButton(),
                        React.createElement("div", { className: styles.leftPanelSecondRow },
                            (!isPaneExpanded ||
                                !isControlFeatureEnabled('tri-horizontalModuleSwitcher')) && (React.createElement(LeftRail, { selectedModule: Module.Mail, activeModuleAction: selectDefaultFolder, onClickLink: this.onClickLink })),
                            isPaneExpanded && (React.createElement("div", { className: styles.leftColumn, style: { width: getFolderListWidth() } },
                                React.createElement(FolderPane, null),
                                this.ShowLeftNavPremiumUpsell() && React.createElement(LeftnavUpsell, null),
                                isControlFeatureEnabled('tri-horizontalModuleSwitcher') && (React.createElement(ModuleSwitcher, { selectedModule: Module.Mail, activeModuleAction: selectDefaultFolder, isHorizontal: true, containerWidth: leftNavWidth, onClickLink: this.onClickLink })))))),
                    React.createElement(ResizeHandle, { className: styles.paddingTop, onResize: this.leftNavResizeHandler }),
                    this.renderRightPane(),
                    composeStore.floatingViewStates.size > 0 && React.createElement(FloatingComposeContainer, null),
                    isMailFeatureEnabled('fwk-ads') && (React.createElement(AdsPanelStub, { isBottom: false, isHidden: isAppPaneUnderlayExpanded() }))),
                isMailFeatureEnabled('fwk-ads') && React.createElement(AdsPanelStub, { isBottom: true })),
            isMailFeatureEnabled('rp-immersiveReader') && React.createElement(ImmersiveReaderContainer, null),
            isMailFeatureEnabled('rp-popouts') && (React.createElement(PopoutContainer, { parentComponent: PopoutSource.Mail })),
            isControlFeatureEnabled('peo-favoritePdls') && (React.createElement(PrivateDistributionlistModalEditor, null)),
            this.ShowDomainConnectFirstStep() && (React.createElement(PremiumDomainConnectFirstStepLightable, { lid: LightningId.PremiumDomainConnectModal, when: function (lightup) { return lightup(); } }))));
    };
    MailModule.prototype.renderNewMessageButton = function () {
        var _this = this;
        var isPaneExpanded = store.mailModule.showFolderPane;
        var isInGroupView = this.showGroupView();
        var currentView = groupHeaderCommandBarStore.navigationButtonSelected;
        var inGroupFiles = isInGroupView && currentView == GroupHeaderNavigationButton.Files;
        return (React.createElement("div", { className: styles.leftPanelFirstRow },
            React.createElement(HamburgerButton, { isPaneExpanded: isPaneExpanded, toggleHamburgerButton: this.toggleFolderPaneExpansion }),
            isPaneExpanded && (React.createElement("div", { className: styles.newMessageButtonWrapper }, inGroupFiles ? null : (React.createElement(CommandButton, { className: classNames(styles.newMessageButton, !isControlFeatureEnabled('tri-horizontalModuleSwitcher') &&
                    styles.newMessageButtonPadding), iconProps: { iconName: "Add" /* Add */ }, text: this.showPublicFolderView()
                    ? mailStrings.newPostAction
                    : mailStrings.newMailAction, onClick: function () {
                    if (!isAnySxSDisplayed()) {
                        var targetId = _this.showPublicFolderView()
                            ? getSelectedPublicFolderId()
                            : getSelectedGroupId();
                        checkAndCreateNewMessage('CommandBar', targetId);
                    }
                }, onMouseOver: function () {
                    lazyOpenCompose.import();
                }, disabled: getMailMenuItemShouldDisable(19 /* NewMessage */) }))))));
    };
    MailModule.prototype.undoAction = function () {
        // do nothing if SxS is showing
        if (!isAnySxSDisplayed()) {
            undoActions.lazyUndo.importAndExecute('Keyboard');
        }
    };
    MailModule.prototype.onEscape = function (evt) {
        // If we are showing immersive reading pane this will only be called if focus was not on RP.
        // If focus was on RP then it will close the immersive RP.
        // MailModule should not close the immersive RP on key press as it is tied to different keys depending on a keyset and not just 'esc'.
        var readingPanePosition = getUserConfiguration().UserOptions
            .GlobalReadingPanePositionReact;
        var isImmersiveReadingPaneShown = readingPanePosition == ReadingPanePosition.Off && store.mailModule.showReadingPane;
        if (!isImmersiveReadingPaneShown && this.searchBoxRef) {
            // Search box is hidden in groups and when preview pane is shown
            this.searchBoxRef.onEscape(evt);
        }
        if (!isImmersiveReadingPaneShown && this.newSearchBoxRef) {
            // Search box is hidden in groups and when preview pane is shown
            exitSearch('Keyboard', SearchScenarioId.Mail);
        }
    };
    MailModule.prototype.gotoSentItems = function () {
        var sentitemsId = folderNameToId('sentitems');
        selectFolder(sentitemsId, 'primaryFolderTree', 'Keyboard' /* actionSource */);
    };
    MailModule.prototype.selectNextRowShortcut = function () {
        var tableView = getSelectedTableView();
        var selectedRows = tableView.selectedRowKeys;
        // Select the next item in immersive mode
        if (!mailStore.mailModule.showListPane && selectedRows.size > 0) {
            markRead.lazyOnNavigateAwayViaUpDown.importAndExecute(tslib_1.__spread(selectedRows.keys())[0], tableView);
            selectNextRow(tableView, MailListItemSelectionSource.CommandBarArrows);
        }
        else {
            selectNextRow(tableView, MailListItemSelectionSource.KeyboardUpDown);
        }
    };
    MailModule.prototype.selectPreviousRowShortcut = function () {
        var tableView = getSelectedTableView();
        var selectedRows = tableView.selectedRowKeys;
        // Select the previous item in immersive mode
        if (!mailStore.mailModule.showListPane && selectedRows.size > 0) {
            markRead.lazyOnNavigateAwayViaUpDown.importAndExecute(selectedRows.keys()[0], tableView);
            selectPreviousRow(tableView, MailListItemSelectionSource.CommandBarArrows);
        }
        else {
            selectPreviousRow(tableView, MailListItemSelectionSource.KeyboardUpDown);
        }
    };
    /**
     * An onResize callback used to update the user config with the new value for folder list's width.
     * This is the same value used in jsMVVM for the whole folder pane. We need to adjust the value slightly
     * to reflect the presense of left rail.
     * @param fullLeftNavWidth - the measured width from the left of the screen to the resize handle
     * @param rightPaneWidth (unused param) - the measured width from the resize handle to the right of the screen
     */
    MailModule.prototype.leftNavResizeHandler = function (fullLeftNavWidth, rightPaneWidth) {
        setFolderPaneWidth(fullLeftNavWidth, FolderPaneExpansionSource.LeftNavResizeExpand);
        lazyTriggerResizeEvent.importAndExecute();
    };
    MailModule.prototype.clearPendingDragHintRemover = function () {
        trace.info('clearPendingDragHintRemover');
        if (this.pendingDragHintRemover) {
            clearInterval(this.pendingDragHintRemover);
            this.pendingDragHintRemover = null;
        }
    };
    MailModule.prototype.setDataItemType = function (newValue) {
        if (store.typeOfItemBeingDragged != newValue) {
            setTypeOfItemBeingDragged(newValue);
        }
    };
    /**
     * Search box is hidden when
     * 1. The preview pane (SxS V1) is opened
     */
    MailModule.prototype.isSearchHidden = function () {
        /**
         * This flight represents SxS's new modal UX. In this experience, the
         * user cannot interact with search while in SxS, so there's no need
         * to hide it. So if this flight is on, just return false.
         */
        if (isAttachmentFeatureEnabled('doc-SxS-V2')) {
            return false;
        }
        return isAnySxSDisplayed();
    };
    MailModule.prototype.isSearchDisabled = function () {
        return this.isPrivateUnjoinedGroup();
    };
    MailModule.prototype.ShowLeftNavPremiumUpsell = function () {
        return (isMailFeatureEnabled('auth-leftNavPremiumUpsell') &&
            !IsChildConsumerUser() &&
            getUserConfiguration().SessionSettings.UserCulture.indexOf('jp') == -1);
    };
    MailModule.prototype.ShowDomainConnectFirstStep = function () {
        var queryStringStartIndex = window.location.href.indexOf('?');
        var queryString = queryStringStartIndex !== -1
            ? window.location.href.slice(queryStringStartIndex + 1)
            : '';
        var queryStringValues = parse(queryString);
        // The test hook query string parameter has the domain name
        var testHook = queryStringValues.testhook;
        return (isMailFeatureEnabled('auth-domainConnectDemandGen') &&
            (testHook != null ||
                (getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox &&
                    (getUserConfiguration().SessionSettings.PremiumAccountOffers & 2) != 2 &&
                    !getUserConfiguration().SessionSettings.IsProsumerConsumerMailbox)));
    };
    tslib_1.__decorate([
        keydownHandler(getCommands().undoAction)
    ], MailModule.prototype, "undoAction", null);
    tslib_1.__decorate([
        keydownHandler('esc', false /* stopPropagation */)
    ], MailModule.prototype, "onEscape", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().openNextItem)
    ], MailModule.prototype, "selectNextRowShortcut", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().openPrevItem)
    ], MailModule.prototype, "selectPreviousRowShortcut", null);
    MailModule = tslib_1.__decorate([
        observer
    ], MailModule);
    return MailModule;
}(React.Component));
export default MailModule;
//# sourceMappingURL=MailModule.js.map